// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "wrapper-2EuuD wrapper-2vQI0";
var _5 = "monthsList-2RDDm";
var _6 = "nav_next-2ArH5";
var _7 = "nav_prev-1Rf34";
var _8 = "monthsList_withPrice-2eawm";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "wrapper", _5 as "monthsList", _6 as "nav_next", _7 as "nav_prev", _8 as "monthsList_withPrice" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "wrapper": _4, "monthsList": _5, "nav_next": _6, "nav_prev": _7, "monthsList_withPrice": _8 }
